import React, { Component } from 'react';
import ReactTable from 'react-table';
import {BeatLoader} from 'react-spinners';
import PropTypes from 'prop-types'
import Modal from 'react-modal';
import {getLoginDistrictInfo} from "../../../server/utilDistrict";
import {_addNotification,_addNotificationError} from '../../../server/util';
import {get, _delete} from '../../../server/actionsNew'
import NotificationSystem from 'react-notification-system';
let userInfo=getLoginDistrictInfo();
const customManageUsersStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
class Users extends Component {
    constructor(props){
        super(props);
        this.state={
            selectSchool:0,
            loading: false,
            search:'',
            userList:[],
            isDistrict:true,
            modalIsOpen:false,
            deleteUserName:'',
            modalRestoreIsOpen:false,
            restoreUserName:''
        }
    }
    componentWillMount=()=>{
        this.props.changeShowHideSchoolFitler(!this.state.isDistrict);
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
        this.getDistrict_SchoolUsers();
    }
    componentWillReceiveProps=(nextProps)=>{
        if(this.state.selectSchool!=nextProps.selectSchool){
            this.setState({selectSchool:nextProps.selectSchool},()=>{
                this.getDistrict_SchoolUsers();
            })
        }
    }
    addNewUsers=(id,rec)=>{
        this.context.router.history.push(`/district/userRecord/${id}`,{
            data:{
                isDistrict:this.state.isDistrict,
                id:id,
                record:rec
            }
        });
    }
    getColumns=()=>{
        let columns = [];
        columns.push({
            accessor: 'fullName',
            id:'fullName',
            Header: 'Name',
            style: {textAlign: 'center'},
            sortable:true,
            defaultSortDesc:true
        });
        columns.push({
            accessor: 'mobileNo',
            id:'mobileNo',
            Header: 'Mobile',
            style: {textAlign: 'center'},
            sortable:true,
            defaultSortDesc:true
        });
        if(!this.state.isDistrict){
            columns.push({
                accessor: 'schoolName',
                id:'schoolName',
                Header: 'school',
                style: {textAlign: 'center'},
                sortable:true,
                defaultSortDesc:true
            });
        }
        columns.push({
            accessor: 'isPrimaryUser',
            id:'isPrimaryUser',
            Header: 'Is Primary User',
            style: {textAlign: 'center'},
            width:100,
            Cell:(props)=>{
                return props.original.isPrimaryUser?'Yes':'No'
            }
        });
        columns.push({
            accessor: 'username',
            id:'username',
            Header: 'User Name',
            style: {textAlign: 'center'},
            sortable:true,
            defaultSortDesc:true
        });
        columns.push({
            accessor: 'isVerified',
            id:'isVerified',
            Header: 'Is Verified ',
            width:100,
            style: {textAlign: 'center'},
           Cell:(props)=>{
               return props.original.isVerified?'Yes':'No'
           }
        });
        columns.push({
            accessor: 'isActive',
            id:'isActive',
            Header: 'Active Status ',
            width:100,
            style: {textAlign: 'center'},
           Cell:(props)=>{
               return props.original.isActive?'Yes':'No'
           }
        });        
        columns.push({
            id:'action',
            Header: 'Action',
            width:110,
            style: {textAlign: 'center'},
            Cell: (props) => (<div>
                <a title="Edit Record" onClick={() =>{
                    const {row}=props;
                    let id=row._original.displayRecId;
                    this.addNewUsers(id,props.original);
                }}><i
                    className="fa fa-pencil-square-o tbl-rounded-icon bg-color-1 fa-icon" /></a>
                    {
                        props.original.isActive?
                        <a title="Delete Record" onClick={() =>{
                            const {row}=props;
                            this.openModal(row._original)
                        }}><i
                            className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon" /></a>:
                        <a title="Active Record" onClick={() =>{
                                const {row}=props;
                                this.openReActiveModal(row._original)
                            }}><i
                                className="fa fa-check-square-o tbl-rounded-icon bg-color-2 fa-icon" /></a>
                    }
                    {
                        props.original.isActive && !props.original.isVerified?
                        <a title="Send Registration Email" onClick={() =>{
                            this.sendRegistrationEmail(props.original)
                        }}><i
                            className="fa fa-paper-plane-o tbl-rounded-icon bg-color-1 fa-icon" /></a>:null
                    }
                

            </div>)
        });
        return columns
    }
    filterData=(data)=>{
        return data.filter(user=>{
            return ((user.fullName||'').toUpperCase().includes((this.state.search||'').toUpperCase())||
            (user.username||'').toUpperCase().includes((this.state.search||'').toUpperCase()))            
        })
    }
    getDistrict_SchoolUsers=()=>{
        const {isDistrict}=this.state;
        this.setState({loading: true, userList:[]}); 
        if(isDistrict){                 
            get(`/districts/${userInfo.districtId}?access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                this.setState({
                    userList: (data.districtUsers||[]).map(user=>{
                       return ( {...user, fullName:`${user.lastName} ${user.firstName}`})
                    }),
                    loading: false
                })             
            }).catch(
                (error) => {  
                    this.setState({loading: false});              
                    console.log('Get Users data response', error)
                }
            );
        }else{
            get(`/mealSchools/search/findByDistrictId?districtId=${userInfo.districtId}&access_token=`).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            }).then(data => {
                const list=data._embedded;
                let users=[];
                (list.mealSchools||[]).map(school=>{
                    const sid=school._links.self.href.split('/').pop()
                    school.schoolUsers.map(user=>{
                        if((this.state.selectSchool==0 || sid==this.state.selectSchool)){
                            users.push( {...user, 
                                fullName:`${user.lastName} ${user.firstName}`,
                                school:school,
                                schoolName:school.schoolName,
                                schoolId:sid
                            });
                        }                        
                     })                        
                 });                
                this.setState({
                    userList: users,
                    loading: false
                });           
            }).catch(
                (error) => {  
                    this.setState({loading: false});              
                    console.log('Get Users data response', error)
                }
            );
        }
    }
    sendRegistrationEmail = (user) => {
        this.setState({loading: true});
        const url=this.state.isDistrict?
            '/districtAccActivation?username=' + encodeURIComponent(user.username) + '&access_token=':
            '/adminAccActivationInfo?schoolId=' + user.schoolId + '&loggedUser=' + encodeURIComponent(userInfo.username) + '&schoolUserName=' + encodeURIComponent(user.username) + '&access_token=';
        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response;
        }).then(data => {
            _addNotification('Successfully sent registration email.', this);
            this.setState({loading: false});
        }).catch(
            (error) => {
                this.setState({loading: false});
                _addNotificationError('Send registration email failed. Please try again later.', this);
                console.log('Send registration email response', error)
            }
        );
    }
    openModal(col) {
        this.setState({modalIsOpen: true,deleteUserName:col.username});
    }
    openReActiveModal(col) {
        this.setState({modalRestoreIsOpen: true,restoreUserName:col.username});
    }
    deleteUser = () => {
        this.setState({loading: true}); 
        let url="";
        if(this.state.isDistrict){
            url='/enableDisableDistrictUser?userName=' + this.state.deleteUserName + '&activeStatus=false&loggedUser=' + userInfo.username + '&access_token=';
            _delete(url)
            .then((response)=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(data => {
                _addNotification('Successfully deactivated user.', this);
                //this.getSchoolList();
                this.setState({
                    loading: false,
                    modalIsOpen: false,
                    deleteUserName:''
                });
                this.getDistrict_SchoolUsers();
                console.log('Access Links Sent', data);
            })
                .catch(
                    (error) => {
                        _addNotificationError('Deactivation failed. Please try again later.', this);
                        console.log('Send Notification Links response', error)
                        this.setState({
                            loading: false,
                            modalIsOpen: false,
                            deleteUserName:''
                        });
                    }
                )

        }else{
            url='/enableDisableSchoolUser?schoolUserName=' + this.state.deleteUserName + '&activeStatus=false&loggedUser=' + userInfo.username + '&access_token=';
            get(url).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response;
            }).then(data => {
                _addNotification('Successfully deactivated admin.', this);
                //this.getSchoolList();
                this.setState({
                    loading: false,
                    modalIsOpen: false,
                    deleteUserName:''
                });
                this.getDistrict_SchoolUsers();
                console.log('Access Links Sent', data);
            })
                .catch(
                    (error) => {
                        _addNotificationError('Deactivation failed. Please try again later.', this);
                        console.log('Send Notification Links response', error)
                        this.setState({
                            loading: false,
                            modalIsOpen: false,
                            deleteUserName:''
                        });
                    }
                )

        }
        
    }
    restoreAdminUsers = () => {
        this.setState({loading: true}); 
        if(this.state.isDistrict){
           const url='/enableDisableDistrictUser?userName=' + this.state.restoreUserName + '&activeStatus=true&loggedUser=' + userInfo.username + '&access_token=';
            _delete(url)
            .then((response)=>{
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(data => {
                _addNotification('User restored Successfully.', this);
                //this.getSchoolList();
                this.setState({
                    loading: false,
                    modalRestoreIsOpen: false,
                    restoreUserName:''
                });
                this.getDistrict_SchoolUsers();
            })
                .catch(
                    (error) => {
                        _addNotificationError('Activation failed. Please try again later.', this);
                        console.log('Send Notification Links response', error)
                        this.setState({
                            loading: false,
                            modalRestoreIsOpen: false,
                            restoreUserName:''
                        });
                    }
                )

        }else{     
        get('/enableDisableSchoolUser?schoolUserName=' + this.state.restoreUserName + '&activeStatus=true&loggedUser=' + userInfo.username + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response;
        }).then(data => {
            _addNotification('User restored Successfully.', this);
            //this.getSchoolList();
            this.setState({
                loading: false,
                modalRestoreIsOpen: false,
                restoreUserName:''
            });
            this.getDistrict_SchoolUsers();
        })
            .catch(
                (error) => {
                    _addNotificationError('Activation failed. Please try again later.', this);
                    console.log('Send Notification Links response', error)
                    this.setState({
                        loading: false,
                        modalRestoreIsOpen: false,
                        restoreUserName:''
                    });
                }
            )
        }
    }
    
    render() {
        userInfo=getLoginDistrictInfo();
        return (
            <div>
                <section>
                <NotificationSystem ref="notificationSystem"/>
            <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000   '}}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-6 col-sm-12 col-xs-12 sectionTitle">
                                <h2>
                                    <span>Manage Users</span>
                                </h2>
                            </div>
                            <div className="col-md-6 col-sm-12 col-xs-12 button-group-section" style={{marginTop:'15px'}}>
                                <button className="btn btn-success button-sm add-btn-sm"
                                   onClick={(e)=>{this.addNewUsers(0)}} ><i className="fa fa-user-plus"/> Add User</button>
                            </div>
                        </div>
                        <div className="row form-group">
                            <div className="col-md-3">
                                <input type="text" placeholder="Search..." value={this.state.search} className="form-control" onChange={(e)=>{
                                    this.setState({search:e.target.value})
                                }} />
                            </div>
                            <div className="col-md-9">
                            <button type="button"
                                        className={this.state.isDistrict?"btn btn-xs btn-success": "btn btn-xs btn-inactive-color"}
                                        style={{
                                            margin: 0,
                                            marginLeft: 3
                                        }}
                                        onClick={() => {
                                            this.setState({isDistrict:true},()=>{
                                                this.props.changeShowHideSchoolFitler(!this.state.isDistrict);
                                                this.getDistrict_SchoolUsers()
                                            })
                                        }}
                                    > District Users
                                </button>
                                <button type="button"
                                        className={!this.state.isDistrict?"btn btn-xs btn-success": "btn btn-xs btn-inactive-color"}
                                        style={{
                                            margin: 0,
                                            marginLeft: 3
                                        }}
                                        onClick={() => {
                                            this.setState({isDistrict:false},()=>{
                                                this.props.changeShowHideSchoolFitler(!this.state.isDistrict);
                                                this.getDistrict_SchoolUsers()
                                            })
                                        }}
                                    > School Users
                                </button>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12">
                                <ReactTable 
                                    columns={this.getColumns()}
                                    data={this.filterData(this.state.userList)}
                                    defaultPageSize={10}
                                    minRows={0}
                                    />
                            </div>
                        </div>
                    </div>
                </section>
                <Modal
                                    isOpen={this.state.modalIsOpen}
                                   // onAfterOpen={this.afterOpenModal}
                                    // onRequestClose={this.closeModal}
                                    style={customManageUsersStyles}
                                >
                                    <div className="modal-header">
                                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Delete
                                            User</h4>
                                            <div className="col-md-6"><button type="button" className="pull-right color-1" onClick={() => this.setState({modalIsOpen: false})}>X</button></div>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure you want to delete this user <b><i>'{this.state.deleteUserName}'</i></b> from Meal Manage service?<br/>
                                            <b><i>You can restore user again from deleted users tab</i></b></p>
                                    </div>
                                    <div className="modal-footer">
                                        <form>
                                            <button type="button" className="btn btn-sm btn-success"
                                                    onClick={() => this.setState({modalIsOpen: false})}
                                                    style={{margin: 0, fontSize: 14}}><i
                                                className="glyphicon glyphicon-remove"/> Cancel
                                            </button>
                                            <button type="button" className="btn btn-sm btn-danger"
                                                    onClick={this.deleteUser}
                                                    style={{margin: 0, marginLeft: 5, fontSize: 14}}><i
                                                className="glyphicon glyphicon-ok"/> Delete
                                            </button>
                                        </form>
                                    </div>
                                </Modal> 
                                <Modal
                                    isOpen={this.state.modalRestoreIsOpen}
                                    onAfterOpen={this.afterRestoreOpenModal}
                                    style={customManageUsersStyles}
                                    contentLabel="Activation"
                                >
                                    <div className="modal-header">
                                        <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Restore
                                            User</h4>
                                            <div className="col-md-6"><button type="button" className="pull-right color-1"  onClick={() => this.setState({modalRestoreIsOpen: false})}>X</button></div>
                                    </div>
                                    <div className="modal-body">
                                        <p>Are you sure you want to restore this user <b><i>'{this.state.restoreUserName}'</i></b></p>      
                                    </div>
                                    <div className="modal-footer">
                                        <form>
                                            <button type="button" className="btn btn-sm btn-success"
                                                    onClick={() => this.setState({modalRestoreIsOpen: false})}
                                                    style={{margin: 0, fontSize: 14}}><i
                                                className="glyphicon glyphicon-remove"/> Cancel
                                            </button>
                                            <button type="button" className="btn btn-sm btn-danger"
                                                    onClick={this.restoreAdminUsers}
                                                    style={{margin: 0, marginLeft: 5, fontSize: 14}}><i
                                                className="glyphicon glyphicon-ok"/> Restore
                                            </button>
                                        </form>
                                    </div>
                                </Modal>
            </div>
        );
    }
}
Users.contextTypes = {
    router: PropTypes.object.isRequired
}
export default Users;


// WEBPACK FOOTER //
// ./src/components/District/Users/index.jsx